/* eslint-disable camelcase */
import OverdueInvoice from '@/app/shared/models/OverdueInvoice'

/**
 * Totals of a single currency. The API never adds up amounts across
 * currencies, so each one keeps its own count, totals and worst delay.
 */
export class CurrencySummary {
  constructor (data) {
    this.currency = data.currency
    this.invoiceCount = data.invoice_count
    this.totalAmount = data.total_amount
    this.pendingAmount = data.pending_amount
    this.maxDaysOverdue = data.max_days_overdue
  }
}

/**
 * Whole payload of GET /finance/overdue-invoices: pagination, the per-currency
 * summary (computed over the entire filtered set, not only the current page)
 * and the invoices of the current page.
 */
export default class OverdueInvoicesReport {
  constructor (data) {
    const payload = data || {}
    const summary = payload.summary || {}

    this.total = payload.total || 0
    this.page = payload.page || 1
    this.pageSize = payload.page_size || 0
    this.pages = payload.pages || 0
    this.currencySummaries = (summary.by_currency || []).map(row => new CurrencySummary(row))
    this.invoices = OverdueInvoice.fromArray(payload.results)
  }

  get hasInvoices () {
    return this.total > 0
  }

  get invoiceCountLabel () {
    return this.total === 1 ? '1 factura impaga' : `${this.total} facturas impagas`
  }

  get maxDaysOverdue () {
    return this.currencySummaries.reduce(
      (worst, summary) => Math.max(worst, summary.maxDaysOverdue || 0),
      0
    )
  }

  get maxDaysOverdueLabel () {
    const days = this.maxDaysOverdue
    return `Hasta ${days} ${days === 1 ? 'día' : 'días'} de atraso`
  }

  /** True when the page does not hold every invoice of the filtered set. */
  get isPartialPage () {
    return this.invoices.length < this.total
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/OverdueInvoicesReport.js